import { render } from "./FormatModal.vue?vue&type=template&id=981c1a46&scoped=true"
import script from "./FormatModal.vue?vue&type=script&lang=js"
export * from "./FormatModal.vue?vue&type=script&lang=js"

import "./FormatModal.vue?vue&type=style&index=0&id=981c1a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981c1a46"]])

export default __exports__